export class PayloadBuilder {
  constructor(initialData = {}) {
    this.payload = { ...initialData };
  }

  set(key, value) {
    this.payload[key] = value;
    return this; // chainable
  }

  setIfExists(key, value) {
    if (value !== undefined && value !== null && value !== '') {
      this.payload[key] = value;
    }
    return this;
  }

  setFromObject(obj, keys) {
    keys.forEach((key) => {
      if (obj[key] !== undefined) {
        this.payload[key] = obj[key];
      }
    });
    return this;
  }

  build() {
    return this.payload;
  }
}